import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, FormControl, Validators} from '@angular/forms';
import { numberValidator } from 'src/app/_validators';
import { Observable } from 'rxjs';
import { ActualizacionDatosService } from '../actualizacion-datos.service';

@Component({
  selector: 'app-datos-basicos',
  standalone: false,
  templateUrl: './datos-basicos.component.html',
  styleUrls: ['./datos-basicos.component.scss', '../actualizacion_datos.scss']
})
export class DatosBasicosComponent implements OnInit {

  @Input()
  datosBasicosForm: UntypedFormGroup;

  public ciudades$: Observable<any>;
  public documentos$: Observable<any>;
  public rhs$: Observable<any>;

  constructor(private actualizacionService: ActualizacionDatosService) { }

  ngOnInit() {
    this.ciudades$ = this.actualizacionService.ciudades$;
    this.documentos$ = this.actualizacionService.documentos$;
    this.rhs$ = this.actualizacionService.rhs$;
  }

  getErrorMessage(controlPath: string) {
    const control = this.datosBasicosForm.get(controlPath);
    return control.hasError('required') ? 'Este campo es requerido' :
        control.hasError('email') ? 'No es un email valido' :
        control.hasError('invalidNumber') ? 'No es un número valido' :
        control.hasError('invalidPhone') ? 'No es un número de telephono valido' :
            '';
  }
}
